document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('MainContent');
  if (!main) return;

  var sections = Array.prototype.slice.call(main.children).filter(function (el) {
    return el.classList && el.classList.contains('shopify-section');
  });

  if (sections.length === 0) return;

  sections[0].classList.add('scroll-reveal-visible');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-reveal-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05,
    rootMargin: '0px 0px -30px 0px'
  });

  sections.slice(1).forEach(function (section) {
    observer.observe(section);
  });
});